import { useNavigate } from "react-router-dom";
import { FolderOpen, FileText, Clock } from "lucide-react";

export function ProjectCard({ project }) {
  const navigate = useNavigate();

  return (
    <div
      onClick={() => navigate(`/projects/${project.id}`)}
      className="border border-[var(--pf-border)] bg-[var(--pf-bg)] p-6 cursor-pointer prompt-card transition-colors duration-150 hover:border-[var(--pf-accent)]"
      data-testid={`project-card-${project.id}`}
    >
      <div className="flex items-start justify-between mb-3">
        <div className="w-8 h-8 bg-[var(--pf-surface)] flex items-center justify-center">
          <FolderOpen className="w-4 h-4 text-[var(--pf-text-secondary)]" />
        </div>
        <div className="flex items-center gap-1 text-xs text-[var(--pf-text-secondary)]">
          <FileText className="w-3 h-3" />
          <span>{project.prompt_count || 0}</span>
        </div>
      </div>
      <h3 className="font-heading font-bold text-base mb-1 truncate">{project.name}</h3>
      {project.description && (
        <p className="text-sm text-[var(--pf-text-secondary)] line-clamp-2 mb-3">{project.description}</p>
      )}
      <div className="flex items-center gap-1 text-xs text-[var(--pf-text-muted)]">
        <Clock className="w-3 h-3" />
        <span>{new Date(project.updated_at || project.created_at).toLocaleDateString()}</span>
      </div>
    </div>
  );
}
